import { render, staticRenderFns } from "./reportMajor.vue?vue&type=template&id=d357d290&scoped=true"
import script from "./reportMajor.vue?vue&type=script&lang=js"
export * from "./reportMajor.vue?vue&type=script&lang=js"
import style0 from "./reportMajor.vue?vue&type=style&index=0&id=d357d290&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX\\qsx-web\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d357d290",
  null
  
)

export default component.exports